<template>
  <div id="index" class="homeindex">
    <dv-loading v-if="loading">Loading...</dv-loading>
    <div v-else>
      <div class="host-body">
        <div class="hometopk">
          <topx></topx>
        </div>
        <div ref="zhezhao" class="zhezhao">
        </div>
        <div class="search">
          <el-select @change="getkeyword" v-model="keyword" filterable placeholder="请选择">
            <el-option
                v-for="item in list"
                :key="item.name"
                :label="item.name"
                :value="item.name">
            </el-option>
          </el-select>
          <div class="resetbut" @click="resetbut">
            <i class="el-icon-refresh"></i>
          </div>
          <!--          <input type="text" v-model="keyword" @keyup.enter="getsearch" placeholder="请输入关键词">-->
        </div>
        <map3d ref="map3d" v-if="isRouterAlive"></map3d>
        <!--        <baidu-map v-if="isRouterAlive && type!=0" @ready="handler"-->
        <!--                   :scroll-wheel-zoom="true" class="map" style="display: flex; flex-direction: column"-->
        <!--                   :center="{lng: 105.404, lat: 39.915}"-->
        <!--                   :zoom="5">-->
        <!--          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>-->
        <!--          <bm-marker v-for="(item,index) in list" :key="index"-->
        <!--                     :position="item.markerPoint"-->
        <!--                     :dragging="false"-->
        <!--                     @click="infoWindowOpen(index)">-->
        <!--            <bm-info-window :show="item.show" @close="infoWindowClose(index)" @open="infoWindowOpen(index)">-->
        <!--              <div class="bminfox">-->
        <!--                &lt;!&ndash;                <span @click="infoWindowClose(index)" class="el-icon-circle-close"></span>&ndash;&gt;-->
        <!--                <p>名称:{{ item.name }} {{ index + 1 }}</p>-->
        <!--                <p>车位数:{{ item.num }}</p>-->
        <!--                <p>是否支持电子支付:{{ item.status ? '是' : '否' }}</p>-->
        <!--              </div>-->
        <!--            </bm-info-window>-->
        <!--          </bm-marker>-->
        <!--        </baidu-map>-->
        <left></left>
        <vcenter></vcenter>
        <right></right>
      </div>
    </div>
  </div>
</template>

<script>

import right from "_c/home/right";
import left from '_c/home/left';
import topx from "_c/topx";
import map3d from "@/views/map3d";
import vcenter from "_c/home/vcenter";
import axios from "axios";

export default {
  data() {
    return {
      loading: true,
      show: false,
      keyword: '',
      list: [
        {
          markerPoint: {lng: 116.401, lat: 39.910},
          name: '北京',
          num: '100',
          status: 1,
          show: false,

        }, {
          markerPoint: {lng: 114.48, lat: 38.03},
          name: '河北',
          num: '100',
          status: 1,
          show: false,

        }, {
          markerPoint: {lng: 117.494021, lat: 39.252968},
          name: '天津',
          num: '100',
          status: 1,
          show: false,

        }, {
          markerPoint: {lng: 118.965805, lat: 36.333689},
          name: '山东',
          num: '100',
          status: 1,
          show: false,

        }, {
          markerPoint: {lng: 128.826756, lat: 47.499887},
          name: '黑龙江',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 118.745037, lat: 44.421612},
          name: '内蒙古',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 126.398313, lat: 43.195906},
          name: '吉林',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 122.718853, lat: 41.393098},
          name: '辽宁',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 112.269189, lat: 36.867724},
          name: '山西',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 86.733741, lat: 42.27368},
          name: '新疆',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 103.364897, lat: 30.983269},
          name: '四川',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 109.104854, lat: 23.763631},
          name: '广西',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 114.035329, lat: 23.763631},
          name: '广东',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 118.303502, lat: 26.111966},
          name: '福建',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 121.688605, lat: 30.983269},
          name: '上海',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 117.199664, lat: 32.617286},
          name: '安徽',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 119.480929, lat: 33.484943},
          name: '江苏',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 107.117946, lat: 26.64227},
          name: '贵州',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 112.269189, lat: 31.426061},
          name: '湖北',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 95.711622, lat: 35.915757},
          name: '青海',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 88.279114, lat: 31.489146},
          name: '西藏',
          num: '100',
          status: 1,
          show: false,
        }, {
          markerPoint: {lng: 106.308465, lat: 37.162795},
          name: '宁夏',
          num: '100',
          status: 1,
          show: false,
        },],
      isRouterAlive: false,
      danyaokulist: [],
      type: 0,
      markerPoint: {lng: 116.404, lat: 39.915}
    };
  },
  components: {
    left,
    right,
    topx,
    map3d,
    vcenter
  },
  mounted() {
    // 火狐兼容避免重复触发resize
    let userAgent = navigator.userAgent
    if (userAgent.indexOf("Firefox") > -1) {
    } else {
      window.addEventListener('resize', this.reload)
    }
    this.cancelLoading();
    this.reload();
  },
  watch: {
    type() {
      this.reload()
    },
  },
  methods: {
    handleSelect(item) {
      console.log(item);
    },
    getkeyword(e) {
      console.log(e)
      var that = this;
      let data = that.list;
      for (var i = 0; i < data.length; i++) {
        if (data[i].name == e) {
          var data2 = [];
          data2.push(data[i].markerPoint.lng)
          data2.push(data[i].markerPoint.lat)
          that.$refs.map3d.setCenter(data2, i)
        }
      }
    },
    resetbut() {
      this.keyword = '';
      this.$refs.map3d.setCenter2()
    },
    // getsearch() {
    //   var that = this;
    //   axios.get('//restapi.amap.com/v3/place/text?key=be862a6b566f949c5f44328c875e9c3d&keywords=' + this.keyword + '&types=&city=&children=&offset=1&page=1&extensions=all')
    //       .then(function (response) {
    //         if (response.data.pois.length > 0) {
    //           that.$refs.map3d.setCenter(response.data.pois[0].location.split(','))
    //         }
    //       })
    //       .catch(function (err) {
    //         console.log(err);
    //       });
    // },
    infoWindowClose(index) {
      this.list[index].show = false
    },
    reload() {
      console.log(12243)
      setTimeout(() => {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true;
        })
      }, 0)
    },
    infoWindowOpen(index) {
      this.list[index].show = true
    },
    handler({BMap, map}) {
      let mapStyle = {
        styleJson: [
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": {
              "color": "#021019"
            }
          },
          {
            "featureType": "highway",
            "elementType": "geometry.fill",
            "stylers": {
              "color": "#000000"
            }
          },
          {
            "featureType": "highway",
            "elementType": "geometry.stroke",
            "stylers": {
              "color": "#147a92"
            }
          },
          {
            "featureType": "arterial",
            "elementType": "geometry.fill",
            "stylers": {
              "color": "#000000"
            }
          },
          {
            "featureType": "arterial",
            "elementType": "geometry.stroke",
            "stylers": {
              "color": "#0b3d51"
            }
          },
          {
            "featureType": "local",
            "elementType": "geometry",
            "stylers": {
              "color": "#000000"
            }
          },
          {
            "featureType": "land",
            "elementType": "all",
            "stylers": {
              "color": "#08304b"
            }
          },
          {
            "featureType": "railway",
            "elementType": "geometry.fill",
            "stylers": {
              "color": "#000000"
            }
          },
          {
            "featureType": "railway",
            "elementType": "geometry.stroke",
            "stylers": {
              "color": "#08304b"
            }
          },
          {
            "featureType": "subway",
            "elementType": "geometry",
            "stylers": {
              "lightness": -70
            }
          },
          {
            "featureType": "building",
            "elementType": "geometry.fill",
            "stylers": {
              "color": "#000000"
            }
          },
          {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": {
              "color": "#857f7f"
            }
          },
          {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": {
              "color": "#000000"
            }
          },
          {
            "featureType": "building",
            "elementType": "geometry",
            "stylers": {
              "color": "#022338"
            }
          },
          {
            "featureType": "green",
            "elementType": "geometry",
            "stylers": {
              "color": "#062032"
            }
          },
          {
            "featureType": "boundary",
            "elementType": "all",
            "stylers": {
              "color": "#1e1c1c"
            }
          },
          {
            "featureType": "manmade",
            "elementType": "geometry",
            "stylers": {
              "color": "#022338"
            }
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": {
              "visibility": "off"
            }
          },
          {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": {
              "visibility": "off"
            }
          },
          {
            "featureType": "all",
            "elementType": "geometry.stroke",
            "stylers": {
              "color": "#0bc6b8ff",
              "hue": "#0bc6b8",
              "visibility": "on"
            }
          }
        ],
      };
      map.setMapStyle(mapStyle);
      if (this.type == 1) {
        map.setMapType(BMAP_SATELLITE_MAP);
      } else if (this.type == 2) {
        map.setMapType(BMAP_NORMAL_MAP);
      } else if (this.type == 3) {
        map.setMapType(BMAP_HYBRID_MAP);
      }
      // map.setMapType(BMAP_HYBRID_MAP);
    },

    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/index.scss";

.el-input__suffix {
  display: none !important;
}

.el-select {
  margin-left: 30px;
}

.el-select-dropdown {
  border: 1px solid rgba(57, 152, 176, 1.00);
  background: rgba(6, 19, 34, 1.00);
}

.el-select-dropdown__item {
  color: rgba(117, 235, 251, 1.00);
}

.el-popper[x-placement^=bottom] .popper__arrow::after {
  border-bottom-color: rgba(6, 17, 32, 1.00);
}

.el-select-dropdown__item.selected {
  color: rgba(117, 235, 251, 1.00);
}

.popper__arrow {
  display: none !important;
}

.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
  background: rgba(57, 152, 176, 1.00);
}

.zhezhao {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 0;
  pointer-events: none;
  top: 0;
  left: 0;
  box-sizing: border-box;
  background: url("../assets/zhezhao.png") no-repeat;
  background-size: 100% 100%;
}

.BMap_pop > div:nth-child(0) {
  display: none;
}

.BMap_pop > div:nth-child(1) {
  display: none;
}

.BMap_pop > div:nth-child(2) {
  display: none;
}

.BMap_pop > div:nth-child(3) {
  display: none;
}

.BMap_pop > div:nth-child(4) {
  display: none;
}

.BMap_pop > div:nth-child(5) {
  display: none;
}

.BMap_pop > div:nth-child(6) {
  display: none;
}

.BMap_pop > div:nth-child(7) {
  display: none;
}

.BMap_pop > div:nth-child(8) {
  display: none;
}

//.BMap_pop > img:nth-child(1) {
//  display: none;
//}
.BMap_pop > img {
  display: none;
}

.BMap_pop > div:nth-child(9) {
  padding: 15px;
  height: auto !important;
  transition: all .35s ease-out;
  background: linear-gradient(to left, #77f0ff, #77f0ff) left top no-repeat, linear-gradient(to bottom, #77f0ff, #77f0ff) left top no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) right top no-repeat, linear-gradient(to bottom, #77f0ff, #77f0ff) right top no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) left bottom no-repeat, linear-gradient(to bottom, #77f0ff, #77f0ff) left bottom no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) right bottom no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) right bottom no-repeat rgba(0, 6, 20, 0.7);
  background-size: 2px 18px, 18px 2px, 2px 18px, 18px 2px;
  border: 1px solid #004566;
  box-shadow: inset 0px 0px 20px 0px #004566;
}

.bminfox {

  p {
    line-height: 20px;
    color: #77F0FF;
  }

  span {
    font-size: 16px;
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}

.BMap_pop .BMap_top {
  display: none;
}

.homebody {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  position: relative;
  width: 100%;
  height: 100%;
}

.shouimg {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  z-index: 1;

  span {
    margin-right: 20px;
    color: red;
    cursor: pointer;
  }
}

.host-body {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1;
}

.homeindex {
  position: fixed;
  width: 100%;
  height: 100%;
}

.map {
  position: fixed;
  z-index: -1;
  width: 100%;
  height: 100%;
  top: 0;
}

.hometopk {
  background: -webkit-linear-gradient(rgba(0, 44, 43, 0.86), rgba(0, 44, 43, 0.36)); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(rgba(0, 44, 43, 0.86), rgba(0, 44, 43, 0.36)); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(rgba(0, 44, 43, 0.86), rgba(0, 44, 43, 0.36)); /* Firefox 3.6 - 15 */
  background: linear-gradient(rgba(0, 44, 43, 0.86), rgba(0, 44, 43, 0.36)); /* 标准的语法（必须放在最后） */
  position: relative;
  z-index: 1;
}

.wxt {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  color: red;
  position: relative;
  top: 100px;

  span {
    margin-left: 15px;
    margin-right: 15px;
  }
}

.search {
  margin: auto;
  width: 400px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  position: absolute;
  z-index: 1000;
  //background: rgba(7, 18, 33, 1.00);
  left: 50%;
  margin-left: -200px;
  top: 1.25rem;
  transition: all .35s ease-out;
  background: linear-gradient(to left, #77f0ff, #77f0ff) left top no-repeat, linear-gradient(to bottom, #77f0ff, #77f0ff) left top no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) right top no-repeat, linear-gradient(to bottom, #77f0ff, #77f0ff) right top no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) left bottom no-repeat, linear-gradient(to bottom, #77f0ff, #77f0ff) left bottom no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) right bottom no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) right bottom no-repeat rgba(0, 6, 20, 0.7);
  background-size: 2px 10px, 10px 2px, 2px 10px, 10px 2px;
  border: 1px solid #004566;
  box-shadow: inset 0px 0px 20px 0px #004566;

  input {
    position: relative;
    width: 90%;
    margin: auto;
    height: 100%;
    background: none;
    border: none;
    color: rgba(112, 225, 241, 1.00);
    font-size: 14px;
    text-align: center;
  }
}

.resetbut {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  position: absolute;
  right: -50px;
  border: 1px solid rgba(1, 69, 102, 1.00);
  height: 50px;
  width: 50px;
  transition: all .35s ease-out;
  background: linear-gradient(to left, #77f0ff, #77f0ff) left top no-repeat, linear-gradient(to bottom, #77f0ff, #77f0ff) left top no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) right top no-repeat, linear-gradient(to bottom, #77f0ff, #77f0ff) right top no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) left bottom no-repeat, linear-gradient(to bottom, #77f0ff, #77f0ff) left bottom no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) right bottom no-repeat, linear-gradient(to left, #77f0ff, #77f0ff) right bottom no-repeat rgba(0, 6, 20, 0.7);
  background-size: 2px 10px, 10px 2px, 2px 10px, 10px 2px;
  border: 1px solid #004566;
  box-shadow: inset 0px 0px 20px 0px #004566;
  cursor: pointer;
  font-size: 24px;
  color: rgba(101, 203, 217, 1.00);
}
</style>
